__turbopack_context__.v({
  "buttons": "invite-modal-module-scss-module__vuZ9Kq__buttons",
  "hint": "invite-modal-module-scss-module__vuZ9Kq__hint",
  "title": "invite-modal-module-scss-module__vuZ9Kq__title",
  "wrap": "invite-modal-module-scss-module__vuZ9Kq__wrap",
});
